import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/testimonials";
export function Testimonials() {
  return <Section className="bg-white" data-id="element-259" data-mp="3mepjurjhftqe">
      <SectionHeading title="What other professionals are saying" intro="Speech therapy professionals share how the Blueprint fits into their planning workflow." data-id="element-260" data-mp="3r78zrv5n70yd" />

      <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-261" data-mp="42t0f4mh6flc">
        {testimonials.map((t, i) => <figure key={i} className="flex flex-col rounded-3xl bg-sky-soft p-6" data-id="element-262" data-mp="925r60ggw6t7" data-mpi={i}>
            <QuoteIcon className="h-8 w-8 text-sky" aria-hidden="true" data-id="element-263" data-mp="e0z2pnc71nqq" />
            <div className="mt-3 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-264" data-mp="e07hn6g838ep">
              {Array.from({
            length: 5
          }).map((_, s) => <StarIcon key={s} className="h-5 w-5 fill-sun text-sun" aria-hidden="true" data-id="element-265" data-mp="2fs3r8aity86u" data-mpi={s} />)}
            </div>
            <blockquote className="mt-3 text-[17px] font-semibold leading-relaxed text-ink" data-id="element-266" data-mp="1slkqvdw3naii">"{t.quote}"</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-267" data-mp="1nt14psjcj723">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-268" data-mp="1ity90yp9ad6s" />
              <div data-id="element-269" data-mp="2bi3tdkcee063">
                <p className="font-display text-lg font-bold text-navy" data-id="element-270" data-mp="2bilxt497rkp3">{t.name}</p>
                <p className="text-sm font-semibold text-ink/70" data-id="element-271" data-mp="26llomkh2i1tr">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <div className="mt-12" data-id="element-272" data-mp="1xjvxlfr3l4wi">
        <CTAButton label="Get your copy for $27" data-id="element-273" data-mp="1xiuceigdb212" />
      </div>
    </Section>;
}